export const COMBO_PAYROLL_SYNC_PENDING = 'pending' as const
export const COMBO_PAYROLL_SYNC_PROCESSING = 'processing' as const
export const COMBO_PAYROLL_SYNC_COMPLETED = 'completed' as const
export const COMBO_PAYROLL_SYNC_FAILED = 'failed' as const
export const COMBO_PAYROLL_SYNC_ALL_STATUS = 'all_status' as const
export const COMBO_PAYROLL_SYNC_PARTIAL = 'partial_synchronization' as const
export const COMBO_PAYROLL_SYNC_UNSYNC = 'unsynchronized' as const

export const ComboPaySynchronizationStatusArray = [
  COMBO_PAYROLL_SYNC_ALL_STATUS,
  COMBO_PAYROLL_SYNC_COMPLETED,
  COMBO_PAYROLL_SYNC_PROCESSING,
  COMBO_PAYROLL_SYNC_FAILED,
  COMBO_PAYROLL_SYNC_PENDING,
  COMBO_PAYROLL_SYNC_PARTIAL,
  COMBO_PAYROLL_SYNC_UNSYNC
] as const

export type ComboPaySynchronizationStatus =
  (typeof ComboPaySynchronizationStatusArray)[number]

export type ComboPayMetaStatusCount = {
  [Key in Exclude<
    ComboPaySynchronizationStatus,
    'processing' | 'partial_synchronization' | 'pending'
  >]: number
}

export type ComboPayMemberSchema = {
  id: number
  employee_id: string
  error: { code: any; message: string }
  firstname: string
  lastname: string
  arhia_status_message: string
  arhia_synchronization_status: Exclude<
    ComboPaySynchronizationStatus,
    'pending'
  >
}

export type ComboPayMemberSynchronizationSchema = {
  id: number
  type: 'user_contract' | 'amendment' | 'membership'
  status: Extract<
    ComboPaySynchronizationStatus,
    'completed' | 'failed' | 'pending'
  >
  status_message: string
  processed_at: string
}

export type ComboPayCredentialSchema = {
  token: string
}

export const ComboPaySynchronizationFieldNameArray = [
  // CIVIL
  'gender',
  'firstname',
  'lastname',
  'birth_name',
  'citizenship',
  'birth_date',
  'birth_country',
  'birth_place',
  'birth_department_code',

  // CONTACT
  'email',
  'mobile_phone',
  'fixed_phone',
  'street_address',
  'complementary_street_address',
  'zip',
  'city',
  'country_of_residence',
  'bank_account_owner',
  'bic',
  'iban',
  'employee_id',

  // HEALTH
  'social_security_number',
  'has_no_health_plan',
  'health_plan_reason',
  'health_plan_reason_end_date'
] as const

export type ComboPaySynchronizationFieldName =
  (typeof ComboPaySynchronizationFieldNameArray)[number]

export const ComboPayrollSyncStatusArray = [
  COMBO_PAYROLL_SYNC_PENDING,
  COMBO_PAYROLL_SYNC_PROCESSING,
  COMBO_PAYROLL_SYNC_COMPLETED,
  COMBO_PAYROLL_SYNC_FAILED
] as const

export type ComboPayrollSynchronizationStatus =
  (typeof ComboPayrollSyncStatusArray)[number]

export type ComboPayrollSyncStatusAtrtributes = {
  payroll_sync_status: ComboPayrollSynchronizationStatus
  payroll_sync_status_message: string
}
